
import axiosInstance from "../services/axiosInstance";
import * as Endpoints from "../entities/Endpoints"

// API to fetch business information
export const fetchBusinessInfoApi = async (coachId) => {
  const response = await axiosInstance.get(`${Endpoints.GET_BUSINESS_INFO_BY_COACH_ID}${coachId}`);
  return response;
};

// API to update business information
export const updateBusinessInfoApi = async (businessData) => {
  const response = await axiosInstance.post(Endpoints.UPDATE_BUSINESS_INFO, businessData);
  return response.data;
};
